<template>
    <div class="list_row">
        <span class="label_title">
            <strong>{{ value.label }}:</strong>
        </span>

        <span class="label_content">
            {{ anwsers }}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        }
    },

    computed: {
        anwsers() {
            return this.value.answer.join(',');
        }
    }
};
</script>
